import { ModalCloseButtonStyle } from './ModalCloseButton.styles';

type ModalCloseButtonProps = {
  onClose: (event?: any) => void;
};

export const ModalCloseButton = ({ onClose }: ModalCloseButtonProps) => {
  return <ModalCloseButtonStyle onClick={onClose} />;
};
